export default "__VITE_ASSET__DwMyOibv__"